import { render, staticRenderFns } from "./AppealsForRoot.vue?vue&type=template&id=3dfd2a2c&"
import script from "./AppealsForRoot.vue?vue&type=script&lang=ts&"
export * from "./AppealsForRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports